import React, { useState, useContext } from 'react'
import { store, actions } from '../../stores/multipost'
import { Button, Card, CardBody, CardHeader } from 'reactstrap'
import FileMenu from './FileMenu'
import FileAsset from './FileAsset'
import SocialAccountProvider from './socialAccountProvider'
import { assetsForFile } from './assetUtils'
import { AlertCircle } from 'react-feather'
import { Alert } from 'reactstrap'

export default function FileSelector() {
  const { dispatch, selectedFiles, selectedAccounts, socialAccounts } = useContext(store)
  const availableProviders = socialAccounts?.map(a => a.attributes.provider) || []
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => setMenuOpen(false)
  const openMenu = () => setMenuOpen(true)

  const onSelectFile = (file) => {
    file.assets = assetsForFile(file, availableProviders)
    file.key = [file.type, file.id].join('-')

    dispatch({
      type: actions.ADD_FILE,
      file: file
    })
    closeMenu()
  }

  let errors = []

  selectedAccounts.forEach(account => {
    const provider = SocialAccountProvider.find(account)
    if(provider.tooManyAssets(selectedFiles)) {
      errors.push(`${provider.title} only allows ${provider.maxFilesPerPost} files per post`)
    }
  })

  return (
    <>
      <Card className="rounded-2 mb-4">
        <FileMenu
          onSelectUpload={onSelectFile}
          isOpen={menuOpen}
          triggerClose={closeMenu}
        />
        <CardHeader className="rounded-top-2 d-flex justify-content-between align-items-center">
          Photos & Video
          <Button color="outline-secondary" size="sm" onClick={openMenu}>
            + Add
          </Button>
        </CardHeader>
        <CardBody className="p-0">
          { selectedFiles.length > 0 ? (
            <div>
              {selectedFiles.map((file, fileIndex) => (
                file.assets.map((asset, assetIndex) => (
                  <FileAsset
                    key={asset.key}
                    file={file}
                    asset={asset}
                    className={fileIndex == 0 && assetIndex == 0 ? "" : "border-top"}
                  />
                ))
              ))}
            </div>
          ) : (
            <p className="text-muted p-3 m-0">none selected</p>
          )}
        </CardBody>
      </Card>
      { errors.length > 0 && (
        errors.map((error, index) => (
          <Alert key={`error-${index}`} color="warning" className="rounded-2 p-2 bold mb-4 d-flex align-items-center">
            <AlertCircle size="18" />
            <span className="ms-2 fw-normal">{error}</span>
          </Alert>
        ))
      )}
    </>
  )
}
